module.exports = __webpack_public_path__ + "img/pxp-logo-white.6d483199.svg";